export default "__VITE_ASSET__C$kVWzi8__"